import { isMobile, isTablet } from '../../utils/deviceTypeHelper';
import { getList } from '../../modules/recentHistory/recentHistory';

export const ITEMS_PER_PAGE = isMobile() ? 2.5 : isTablet() ? 4 : 6;

const getCurrentItem = ({ itemId }) => {
    return itemId
        ? {
              itemId,
              timestamp: new Date().getTime(),
          }
        : null;
};

export const hasRecentlyViewedItems = ({ itemId, minItems = Math.floor(ITEMS_PER_PAGE) }) => {
    const recentItems = getList(null, getCurrentItem({ itemId }), minItems);
    return recentItems.length >= minItems;
};

export const getRecentlyViewedItems = ({ itemId }) => {
    const recentItems = getList(null, getCurrentItem({ itemId }), 12);
    return recentItems.reverse();
};



// WEBPACK FOOTER //
// ./assets/js/global/components/RecentlyViewedItems/recentlyViewedItemsHelpers.es.js